import React from "react";
import SignupForm from "./components/SignupForm";
import "./index.css";
import "./App.css";
import { Footer } from "./Footer/Footer";

function App() {
  return (
    <div className="app-root">
      <div className="main-content">
        <SignupForm />
      </div>
      <Footer />
    </div>
  );
}

export default App;